import { Box, Button, Grid } from "@material-ui/core"
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator"
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { useForm } from "../../hooks/useForm";
import { useDispatch, useSelector } from "react-redux";
import {  limpiarDatosSuspensionEmpresa, nuevaSolicitudComunicacion, traerDatosSuspensionEmpresa } from "../../actions/comunicacionConEmpresas/comunicacionConEmpresas";
import { useEffect } from "react";
import BuscadorEmpresas from "../empresas/BuscadorEmpresas";
import { AREAS_USUARIOS, ESTADOS_BANDEJAS_SUSPENSION } from "../../utils/constants";
import { empresaLimpiar } from "../../actions/empresas/empresas";

export const FormNuevaSolicitud = (props) => {
    const dispatch = useDispatch();
    const { areas: areasUsuario } = useSelector((state) => state.auth);
    const tieneAreaAfiliaciones = areasUsuario.find((area) => area.idArea === AREAS_USUARIOS.NACIONAL);
    const { solicitud } = props;
    const formInicial = {
        cuit: "",
        denominacion: "",
        cantAfiliados: "",
        telefono: "",
        mail: "",
        mensaje: ""
    }

    const [formValues, handleInputChange] = useForm(solicitud ? solicitud : formInicial);
    const { datosSuspensionEmpresa, empresaSeleccionada } = useSelector((state) => state.comunicacionEmpresas);

    useEffect(() => {
        if (empresaSeleccionada !== null) {
            dispatch(traerDatosSuspensionEmpresa(empresaSeleccionada.cuit));
            formValues.telefono = empresaSeleccionada.telefono;
            formValues.mail = empresaSeleccionada.email;
        }
    }, [dispatch, empresaSeleccionada])

    const handleSave = () => {
        const data = {
            Cuit: empresaSeleccionada.cuit,
            IdEstado: ESTADOS_BANDEJAS_SUSPENSION.CONTESTADOS,
            IdOrigen: tieneAreaAfiliaciones ? AREAS_USUARIOS.NACIONAL : AREAS_USUARIOS.MESA_DE_AYUDA ,
            IdDestino: tieneAreaAfiliaciones ? AREAS_USUARIOS.MESA_DE_AYUDA : AREAS_USUARIOS.NACIONAL,
            Observaciones: formValues.mensaje,
            Telefono: formValues.telefono,
            Mail: formValues.mail
        }
        dispatch(nuevaSolicitudComunicacion(data));
        dispatch(empresaLimpiar());
        dispatch(limpiarDatosSuspensionEmpresa());
        dispatch(props.cerrarModal);
    }
    console.log(empresaSeleccionada)
    const handleCancel = () => {
        dispatch(empresaLimpiar());
        dispatch(limpiarDatosSuspensionEmpresa());
        dispatch(props.cerrarModal)
    }
    return (
        <ValidatorForm onSubmit={handleSave}>
            <Grid container style={{ padding: 25 }}>
                <Grid item xs={12} md={12} style={{ marginLeft: '25%' }}>
                    <BuscadorEmpresas esComunicacion={true} />
                </Grid>
                <Grid item xs={12} md={2} >
                    <TextValidator
                        value={empresaSeleccionada?.cuit || ""}
                        name="cuit"
                        label="Cuit"
                        onChange={handleInputChange}
                        autoComplete="off"
                        fullWidth
                        disabled={true}
                        validators={["required"]}
                    />
                </Grid>
                <Grid item xs={12} md={8} style={{ marginLeft: '0.5rem' }}>
                    <TextValidator
                        value={empresaSeleccionada?.denominacion || ""}
                        name="denominacion"
                        label="Asociacion"
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        disabled={true}
                        validators={["required"]}
                    />
                </Grid>
                <Grid item xs={12} md={1} style={{ marginLeft: '0.5rem' }}>
                    <TextValidator
                        value={datosSuspensionEmpresa?.cant_Afi || ""}
                        name="cantAfiliados"
                        label="Cant. Afiliados"
                        autoComplete="off"
                        fullWidth
                        disabled={true}
                    />
                </Grid>
                <Grid item xs={12} md={5}>
                    <TextValidator
                        value={formValues.telefono}
                        name="telefono"
                        label="Telefono"
                        autoComplete="off"
                        fullWidth
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid item xs={12} md={6} style={{ marginLeft: '0.5rem' }}>
                    <TextValidator
                        value={formValues.mail}
                        name="mail"
                        label="Email"
                        autoComplete="off"
                        fullWidth
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid item xs={12} md={12}>
                    <Box>
                        <Grid>
                            <TextValidator
                                value={formValues.mensaje}
                                onChange={handleInputChange}
                                margin="normal"
                                label="Mensaje"
                                name="mensaje"
                                autoComplete="off"
                                validators={["required"]}
                                fullWidth
                                errorMessages={["El motivo de aceptación es requerido"]}
                                multiline={true}
                                rows={3}
                                rowsMax={8}
                            />
                        </Grid>
                    </Box>
                </Grid>
                <Grid container style={{ padding: 25 }} >
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={handleCancel}
                            >
                                CANCELAR
                            </Button>
                            {
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<SaveIcon />}
                                    type='submit'
                                    style={{ marginLeft: "0.5rem" }}
                                >
                                    ENVIAR
                                </Button>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm>
    )
}